export const presentModeActionIconCss = {
  "path, rect": {
    stroke: "currentColor",
  },
};
